export const CUSTOM_ARTICLE_PAGE_GET_ARTICLE_CASE =
  'Supporting Helle’s Journey to a More Accessible Home';
export const BANNER_SECTION_LINKEDIN_URL =
  'https://www.linkedin.com/company/the-modern-builder/?viewAsMember=true';
export const BANNER_SECTION_FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=';
export const MAX_MOBILE_SCREEN_WIDTH = 768;
export const OTHER = 'other';
export const CRITERIA = 'criteria';

/**
 * Constants for image variant prefixes and sizes
 */
export const IMAGE_VARIANTS = {
  PREFIX: 'listing-card',
  SIZES: {
    BASE: 400,
    DOUBLE: 800,
    QUAD: 1600,
    SEXTUPLE: 2400,
  },
};

export const IMAGE_FIELDS = [
  'variants.default', // Original
  'variants.scaled-small', // Scaled variants
  'variants.scaled-medium',
  'variants.scaled-large',
  'variants.scaled-xlarge',
  'variants.facebook', // Social media
  'variants.twitter',
  'variants.square-small', // Avatars
  'variants.square-small2x',
];

export const SUPPLIER_ID = 'sid';
export const LISTING_ID = 'lid';
export const POST_EDIT = 'post_edit';

export const ABOUT = 'about';
export const LISTINGS = 'listings';

export const sampleEstimationData = {
  supplierMeta: {
    supplier1: {
      supplierId: '68553044-171f-4f26-8ae1-f88ba0e5aa5f',
      supplierName: 'BuildMax Co.',
    },
  },
  stage1: {
    supplier1: {
      superstructureUpToDPC: '350',
      undergroundDrainage: '12000',
    },
  },
  stage2: {
    supplier1: {
      externalWallStructure: '15000',
    },
  },
  stage3: {
    supplier1: {
      roofCoveringsExcFinishes: '8900',
    },
  },
  stage4: {
    supplier1: {
      externalRendering: '2200',
      firstFixJoinery: '3300',
    },
  },
  stage5: {
    supplier1: {
      decoration: '4500',
      secondFixJoinery: '3200',
      floorFinishes: '1900',
      utilityRoomFixturesFittings: '850',
    },
    kitchenFixturesFittings: {
      entries: [
        {
          supplier1: '1200',
          supplier2: '1100',
        },
        {
          supplier1: '1250',
          supplier2: '1125',
        },
      ],
    },
    addAdditionalBathrooms: {
      entries: [],
    },
  },
  professionalFees: {
    supplier1: {
      projectManagement: '5000',
      vatRefundSpecialist: '1300',
    },
  },
  property: 'Modern Duplex',
  propertySize: '850 m²',
  foundationSize: '700 m²',
  projectArea: null,
};
